// Mac installer download config, shared by all Mac download buttons.
// Override the URL with REACT_APP_MAC_INSTALLER_URL when the real .dmg is hosted.
export const MAC_INSTALLER_URL =
  process.env.REACT_APP_MAC_INSTALLER_URL ||
  "https://zerotyping.ai/ztaupdate/ZeroTyping.dmg";

export const MAC_FILENAME = "ZeroTyping.dmg";
